import $ from "jquery";

$.fn.animate_Text = function() {
  let string = this.text();
  return this.each(function(){
    let $this = $(this);
    $this.html(string.replace(/./g, '<span class="new">$&</span>'));
    $this.find('span.new').each(function(i, el){
      setTimeout(function(){ $(el).addClass('div_opacity'); }, 50 * i);
    });
  });
};

let $animationHeaderTitle = $('.animation-header-title');
if ($animationHeaderTitle.length > 0) {
  $animationHeaderTitle.show();
  $animationHeaderTitle.animate_Text();
}

let $animationHeaderText = $('.animation-header-text');
if ($animationHeaderText.length > 0) {
  $animationHeaderText.show();
  $animationHeaderText.animate_Text();
}




window.addEventListener('scroll', function() {
  let scrollPosition = window.scrollY || window.pageYOffset;
  let svgContainer = document.getElementById('svg-container');

  if (svgContainer) {
    if (scrollPosition > 0) {
      svgContainer.classList.add('scattered');
    } else {
      svgContainer.classList.remove('scattered');
    }
  }
});




const headerBg = document.querySelector('.header-bg');
const headerCircle = document.querySelector('.header-circle');
const delay = 10; // задержка в миллисекундах
let mouseX = 0;
let mouseY = 0;

if (headerBg && headerCircle) {
  headerBg.addEventListener('mousemove', function(e) {
    mouseX = e.clientX;
    mouseY = e.clientY;
  });

  setInterval(moveCircle, 20);
}

function moveCircle() {
  let rect = headerBg.getBoundingClientRect();
  let bgX = rect.left;
  let bgY = rect.top;
  let targetX = bgX + mouseX - delay;
  let targetY = bgY + mouseY - delay;
  let currentX = parseFloat(headerCircle.style.left) || 0;
  let currentY = parseFloat(headerCircle.style.top) || 0;
  let dx = (targetX - currentX) * 0.1;
  let dy = (targetY - currentY) * 0.1;
  headerCircle.style.left = currentX + dx + 'px';
  headerCircle.style.top = currentY + dy + 'px';
}



$(window).scroll(function() {
  let servicesContainer = $('.services');
  let titleWrapper = $('.services-title-wrapper');

  if (servicesContainer.length > 0 && titleWrapper.length > 0) {
    if ($(window).scrollTop() >= servicesContainer.offset().top && $(window).scrollTop() <= (servicesContainer.offset().top + servicesContainer.outerHeight() - titleWrapper.outerHeight())) {
      titleWrapper.addClass('fixed');
    } else {
      titleWrapper.removeClass('fixed');
    }
  }
});

